import {
  Component,
  OnInit,
  Input,
  ViewEncapsulation,
  ViewChild,
  ElementRef,
  HostListener,
} from "@angular/core";
import { ApiResponse } from "src/app/models/apiresponse";
import { ConsentDetail } from "src/app/models/consentDetail";
import { orderSummary } from "src/app/models/orderSummary";
import { CustomerAcknowledgementService } from "src/app/services/customer-acknowledgement.service";
import { CAConstant } from "src/app/shared/constant";
import moment from "moment";
import { tncMapping } from "../../class/tnc-mapping";
import { finalize } from "rxjs/operators";
import { LoadingBarComponent } from "../loading-bar/loading-bar.component";
import { DomSanitizer } from "@angular/platform-browser";
declare function logGaEvent(a: any): any;

@Component({
    selector: "app-customer-acknowledgement-form",
    templateUrl: "./customer-acknowledgement-form.component.html",
    styleUrls: ["./customer-acknowledgement-form.component.scss"],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CustomerAcknowledgementFormComponent implements OnInit {
  @Input() caId: string = "";
  @Input() channelCode: string = "";
  @Input() ridPresent: boolean = false;
  @Input() acceptString: string = "I Accept";

  @ViewChild(LoadingBarComponent) loadingBar: LoadingBarComponent;

  order: orderSummary;
  acknowledgement_text = CAConstant.ACKNOWLEDGEMET_TEXT;
  isSubmitted: boolean = false;

  languageId: number = 1;
  listOfTnC: any[] = [];

  orderIsNotExist: boolean = false;
  listenToAudio: boolean = false;
  toPlayAudio: boolean = false;
  withTimeStamp: boolean = false;
  termscheck: boolean = false;

  constructor(
    public customerAcknowledgementService: CustomerAcknowledgementService,
    private sanitized: DomSanitizer,
    private elementRef: ElementRef
  ) {}

  @HostListener("window:click", ["$event"]) onClick(event) {
    if (
      event.target === this.elementRef.nativeElement.querySelector("#audioPlay")
    ) {
      this.playAudio();
    }
  }

  ngOnInit() {
    if (this.caId) {
      this.getOrderDetails();
    }
  }

  getIsFromRP(): boolean {
    return this.channelCode === CAConstant.RP_CHANNEL_CODE;
  }

  getOrderDetails() {
    this.customerAcknowledgementService?.getOrderDetails(this.caId).subscribe(
      async (res) => {
        if (res?.status === CAConstant.SUCCESS_STATUS && res?.responseData) {
          this.order = res.responseData;
          if (
            this.order?.orderSummary.orderid &&
            this.order?.orderSummary.orderid.endsWith("A")
          ) {
            this.order.orderSummary.orderid =
              this.order?.orderSummary.orderid.slice(0, -1);
          }

          if (this.order.devices && this.order.devices.length > 0) {
            for (var a of this.order.devices) {
              if (a.contractype === "K2") {
                a.contractypedisplay = "Normal Contract";
              } else {
                a.contractypedisplay = a.contractype;
              }
            }
          }

          if (
            this.order.additionalDevices &&
            this.order.additionalDevices.length > 0
          ) {
            for (var b of this.order.additionalDevices) {
              if (b.contracttype === "K2") {
                b.contractypedisplay = "Normal Contract";
              } else {
                b.contractypedisplay = b.contracttype;
              }
            }
          }
          await this.getSSTCConsentByProduct(this.order);
          // if (
          //   this.order.orderSummary.channel.toUpperCase() === "MOS" ||
          //   this.order.orderSummary.channel.toUpperCase() === "HOS"
          // ) {
          //   logGaEvent({
          //     event: "ecommerce_checkout",
          //     ecommerce: {
          //       checkout: {
          //         actionField: { step: 41 },
          //         products: this.productsForGa,
          //       },
          //     },
          //   });
          // }
        } else {
          this.orderIsNotExist = true;
          this.handleError(res);
        }
      },
      (error) => {
        this.orderIsNotExist = true;
        this.handleError(error);
      }
    );
  }

  async getSSTCConsentByProduct(order: orderSummary) {
    let planname;
    if (order.orderSummaryItems.length > 0) {
      let checkMUPfibre = order.orderSummaryItems.find(
        (e) => e.planname !== null && e.planname.includes("Maxis Fibre")
      );
      let checkHomefibre = order.orderSummaryItems.find(
        (e) => e.planname !== null && e.planname.includes("Maxis Home")
      );
      let checkMUPpostpaid = order.orderSummaryItems.find(
        (e2) =>
          e2.planname !== null &&
          (e2.planname.includes("Maxis Postpaid") ||
            e2.planname.includes("Maxis Unlimited Postpaid"))
      );

      let checkPostPaid68 = order.orderSummaryItems.find(
        (e2) =>
          e2.planname !== null && e2.planname.includes("Maxis Postpaid 68")
      );

      let checkMaxisShare48 = order.orderSummaryItems.find(
        (e2) =>
          e2.planname !== null &&
          e2.planname.includes("Maxis Postpaid Share 48")
      );

      if (checkMUPpostpaid !== undefined && checkMUPfibre !== undefined) {
        planname = "Maxis Fibre + Maxis Postpaid 68";
      } else if (
        checkMUPpostpaid !== undefined &&
        checkHomefibre !== undefined
      ) {
        planname = "Maxis FWBB + MUP";
      } else if (
        checkMaxisShare48 !== undefined &&
        checkPostPaid68 !== undefined
      ) {
        planname = "Maxis Postpaid 68 + SUPP";
      } else {
        if (order.orderSummaryItems[0]?.planname !== null) {
          planname = order.orderSummaryItems[0]?.planname;
        } else if (order.orderSummaryItems[1]?.planname) {
          planname = order.orderSummaryItems[1]?.planname;
        }
      }
    }
    let checkZerolutionAccessories;
    if (order.additionalDevices.length > 0) {
      checkZerolutionAccessories = order.additionalDevices.find(
        (e3) =>
          e3.contracttype !== null && e3.contracttype.includes("Zerolution")
      );
    }

    let contracttype =
      order.devices.length > 0 && order.devices[0]?.contractype !== null
        ? order.devices[0]?.contractype
        : checkZerolutionAccessories !== undefined
        ? "Zerolution"
        : null;

    if (order.devices.length === 0 && order.additionalDevices.length === 0) {
      contracttype = "No Device";
    }

    const sstcCategory = tncMapping.getSSTCCategory(
      planname,
      order.orderSummary?.custsubtype,
      order.orderSummaryItems[0]?.familytype,
      contracttype
    );
    const gtcCategory = tncMapping.getGeneralTermsCategory(
      planname,
      order.orderSummary?.custsubtype,
      order.orderSummaryItems[0]?.familytype
    );

    this.listOfTnC = [];

    let IAgreeText: string = CAConstant.AGREE_FOR_URL_PLACEMENT;

    await this.customerAcknowledgementService
      .getTnCbyProductCategory(this.languageId, gtcCategory)
      .pipe(
        finalize(async () => {
          await this.customerAcknowledgementService
            .getTnCbyProductCategory(this.languageId, sstcCategory)
            .pipe(
              finalize(async () => {
                this.listOfTnC.push({
                  value: CAConstant.WISH_TO_SUBSCRIBE,
                });
                this.listOfTnC.push({
                  value: CAConstant.INFO_IS_CORRECT,
                });
                this.listOfTnC.push({ value: IAgreeText });
                this.listOfTnC.push({
                  value: CAConstant.MAXIS_PRIVACY_STATEMENT_FULL,
                });
                this.listOfTnC.push({
                  value: CAConstant.DEVICE_CARE,
                });
                // if condition match for ECOMZEROLUTIONAUDIO
                if (
                  tncMapping.isEcomZerolutionAudio(
                    order.orderSummaryItems[0]?.planname,
                    order.orderSummary?.custsubtype,
                    order.orderSummaryItems[0]?.familytype,
                    order.devices[0]?.contractype
                  )
                ) {
                  this.listOfTnC.push({
                    value: CAConstant.ECOMZEROLUTIONAUDIO,
                  });
                };
                this.listOfTnC.push({
                  value: CAConstant.FEE_CHARGED,
                });
              })
            )
            .subscribe((res: ApiResponse) => {
              let data: ConsentDetail = res.responseData;
              if (
                res.status === CAConstant.SUCCESS_STATUS &&
                data?.contenturl
              ) {
                IAgreeText = IAgreeText.replace(
                  "sstcUrl",
                  `<a target='_blank' href='` +
                    data.contenturl +
                    `'>Service Specific Terms and Conditions</a>`
                );
              } else {
                IAgreeText = IAgreeText.replace(
                  "sstcUrl",
                  CAConstant.SSTC_FullText
                );
                if (gtcCategory)
                  console.log(
                    "Error: " +
                      res.violations[0].message +
                      " for " +
                      sstcCategory
                  );
              }
            });
        })
      )
      .subscribe((res: ApiResponse) => {
        let data: ConsentDetail = res.responseData;
        if (res.status === CAConstant.SUCCESS_STATUS && data?.contenturl) {
          IAgreeText = IAgreeText.replace(
            "gtcUrl",
            "<a target='_blank' href='" +
              data.contenturl +
              "'>General Terms and Conditions</a>"
          );
        } else {
          IAgreeText = IAgreeText.replace("gtcUrl", CAConstant.GTC_FullText);
          if (sstcCategory)
            console.log(
              "Error: " + res.violations[0].message + " for " + sstcCategory
            );
        }
      });
  }

  onSubmitConsentForm() {
    logGaEvent({
      event: "eventClicks",
      gaCategory: "CTA Button",
      gaAction: this.acceptString,
      gaLabel: this.order.orderSummary.channel.toUpperCase(),
    });
    this.isSubmitted = true;
    this.loadingBar.show();

    //pdf will be generate at API
    this.customerAcknowledgementService
      .submitConsent(this.caId)
      .pipe(
        finalize(() => {
          this.isSubmitted = false;
          this.loadingBar.hide();
        })
      )
      .subscribe((res) => {
        if (res.status === CAConstant.SUCCESS_STATUS) {
          console.log("submit consent and sent pdf to email ");
          const date = moment(moment().toISOString()).format(
            CAConstant.pdfFileDateFormatConstant
          );
          const nav = window.navigator as any;

          if (res.responseData.file !== "") {
            let byteChar = atob(res.responseData.file);
            let byteArray = new Array(byteChar.length);
            for (let i = 0; i < byteChar.length; i++) {
              byteArray[i] = byteChar.charCodeAt(i);
            }
            let uIntArray = new Uint8Array(byteArray);
            let blob = new Blob([uIntArray], { type: "application/pdf" });
            if (
              nav.userAgent.match(
                /SAMSUNG|Samsung|SGH-[I|N|T]|GT-[I|N]|SM-[A|N|P|T|Z]|SHV-E|SCH-[I|J|R|S]|SPH-L/i
              )
            ) {
              var url = window.URL || window.webkitURL;
              window.open(url.createObjectURL(blob));
            } else if (nav.userAgent.match(/safari/i)) {
              const link = document.createElement("a");
              link.href = URL.createObjectURL(blob);
              link.target = "_blank";
              link.download =
                "Acknowledgement_Order" +
                res.responseData.orderid.slice(0, -1) +
                "_" +
                date +
                ".pdf";
              document.body.appendChild(link);
              link.click();
            } else {
              if (nav && nav.msSaveOrOpenBlob) {
                nav.msSaveOrOpenBlob(
                  blob,
                  "Acknowledgement_Order" +
                    res.responseData.orderid.slice(0, -1) +
                    "_" +
                    date +
                    ".pdf"
                );
              } else {
                // Download PDF in Chrome etc.
                const source = `data:application/pdf;base64,${res.responseData.file}`;
                const link = document.createElement("a");
                link.href = source;
                link.download =
                  "Acknowledgement_Order" +
                  res.responseData.orderid.slice(0, -1) +
                  "_" +
                  date +
                  ".pdf";
                link.click();
              }
            }
          }
          if (
            res.responseData.redirectURL &&
            res.responseData.redirectURL !== null
          ) {
            //this.gaCommerceCheckout();
            window.location.href =
              res.responseData.redirectURL +
              (res.responseData.redirectURL.includes("?") ? "" : "?") +
              "ca_return=" +
              this.order.orderSummary.channel.toLowerCase() +
              "_ordersummary";
          } else {
            this.acceptString = `Accepted on \n${res.responseData.date}`;
            this.orderIsNotExist = true;
            this.withTimeStamp = true;
          }
        } else {
          this.handleError(res);
        }
      });
  }

  get productsForGa() {
    let data = [];
    const device = this.order.devices.map((c) => ({
      name: c.devicename,
      id: c.itemsid,
      price: "",
      brand: "",
      category: "",
      variant: c.storagesize,
      dimension12: c.contractype,
      dimension13: c.color,
      dimension35: "",
      dimension95: "", //if applicable or else set N/A
    }));
    data = data.concat(device);
    const plan = this.order.orderSummaryItems.map((c) => ({
      name: c.planname,
      id: c.summaryid,
      price: "",
      brand: "",
      category: "",
      variant: "",
      dimension12: "",
      dimension35: "",
      dimension95: "", //if applicable or else set N/A
    }));
    data = data.concat(plan);
    const addOn = this.order.additionalDevices.map((c) => ({
      name: c.accessoryname,
      id: c.itemsid,
      price: "",
      brand: "",
      category: "",
      variant: c.storagesize,
      dimension12: c.contracttype,
      dimension35: "",
      dimension95: "", //if applicable or else set N/A
    }));
    data = data.concat(addOn);

    return data;
  }

  gaCommerceCheckout() {
    if (
      this.order.orderSummary.channel.toUpperCase() === "MOS" ||
      this.order.orderSummary.channel.toUpperCase() === "HOS"
    )
      logGaEvent({
        event: "ecommerce_checkout",
        ecommerce: {
          checkout: {
            actionField: { step: 42 },
            products: this.productsForGa,
          },
        },
      });
  }

  bypassSecurityTrustHtml(html: string) {
    return this.sanitized.bypassSecurityTrustHtml(html);
  }

  private handleError(error: ApiResponse) {
    if (error.violations) {
      let message = "";
      for (const violation of (error as ApiResponse).violations) {
        message += violation.message + " ";
      }
      alert(message);
    } else {
      alert("Error: " + error.message);
    }
  }

  getOrderDate(orderDate: Date): string {
    return orderDate
      ? moment(orderDate).format(CAConstant.dateFormatConstant)
      : "";
  }

  playAudio() {
    if (this.listenToAudio) return;
    var audio: any = document.getElementById("audio");
    audio.load();
    audio.play();
    this.listenToAudio = true;
    audio.onended = () => {
      this.listenToAudio = false;
    };
  }
}
